
//const baseUrl="http://localhost:3000/api"
const baseUrl="https://partnerbe.myschoolwizard.com/api"
const azureFunctionVendorFrontendKey="sMdZ8JGWBo4Veit7vUnVN54spQYm9qdTsHediQIehGp5AzFuyfsiFQ=="
const delhiveryTrackUrl="https://www.delhivery.com/track/package/"

const configurations = {


    baseUrl,
    azureFunctionVendorFrontendKey,
    delhiveryTrackUrl
}

export default configurations;
